import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type UserDefinedObject = {
    additionalColumnValues: Record<Uuid, unknown>;
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    id: Uuid;
    revisionId: Uuid;
    isDeleted: boolean;
    templateId: Uuid;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
};

export type UserDefinedObjectCudLog = UserDefinedObject;

export const userDefinedObjectValidator: zod.ZodType<UserDefinedObject> = zod.strictObject({
    additionalColumnValues: zod.record(uuidZodValidator, zod.unknown()),
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    id: uuidZodValidator,
    revisionId: uuidZodValidator,
    isDeleted: zod.boolean(),
    templateId: uuidZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
});

export const userDefinedObjectCudLogValidator: zod.ZodType<UserDefinedObjectCudLog> = userDefinedObjectValidator;
